export const textPreviewExtensions = ['csv', 'json', 'txt', 'xml'];
export const imagePreviewExtensions = ['bmp', 'gif', 'jpeg', 'jpg', 'png', 'svg', 'webp'];

export const getFileExtension = (fileName = '') => fileName.split('.').pop()?.toLowerCase() || '';

export const getBadgeColor = (fileName) => {
  const extension = getFileExtension(fileName);

  if (extension === 'pdf') return '#1f6feb';
  if (['stp', 'step'].includes(extension)) return '#7c3aed';
  if (imagePreviewExtensions.includes(extension)) return '#059669';
  if (textPreviewExtensions.includes(extension)) return '#b45309';

  return '#6d7175';
};

// Same rendering Chonky used for modDate (intl medium date + short time).
export const formatFileDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('en', { dateStyle: 'medium', timeStyle: 'short' });
};
